import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Instagram, Facebook } from 'lucide-react';

const Footer = ({ language }) => {
  const content = {
    mr: {
      contactTitle: 'संपर्क माहिती',
      address: 'मिठमुंबरी, देवगड तालुका, जि. सिंधुदुर्ग ४१६६१२',
      phone: '9869127240',
      email: 'gpmithmumbari01@gmail.com',

      quickLinksTitle: 'द्रुत दुवे',
      links: [
        { label: 'मुख्य पान', path: '/' },
        { label: 'आमच्याविषयी', path: '/about' },
        { label: 'नागरीक सेवा', path: '/services' },
        { label: 'घडामोडी', path: '/events' },
        { label: 'संपर्क', path: '/contact' }
      ],

      govLinksTitle: 'महत्त्वाचे दुवे',

      govLinksShort: [
        { label: 'पंचायती राज मंत्रालय', url: 'https://rdd.maharashtra.gov.in/en/' },
        { label: 'महाराष्ट्र शासन', url: 'https://www.maharashtra.gov.in' },
        { label: 'जिल्हाधिकारी कार्यालय', url: 'https://sindhudurg.nic.in' },
        { label: 'डिजिटल इंडिया पोर्टल', url: 'https://www.digitalindia.gov.in' },
        { label: 'पीएम किसान पोर्टल', url: 'https://pmkisan.gov.in' },
        { label: 'आयुष्मान भारत', url: 'https://beneficiary.nha.gov.in/' },
        { label: 'तक्रार निवारण पोर्टल', url: 'https://grievances.maharashtra.gov.in/mr' },
        { label: 'शासन निर्णय', url: 'https://gr.maharashtra.gov.in/1125/%e0%a4%ae%e0%a5%81%e0%a4%96%e0%a5%8d%e0%a4%af-%e0%a4%aa%e0%a5%83%e0%a4%b7%e0%a5%8d%e0%a4%a0' }
      ],

      govLinksLong: [
        {
          label: 'dccrs.gov.in या पोर्टलवर जन्म मृत्यू नोंदी समविष्ट करणे',
          url: 'https://dc.crsorgi.gov.in/crs/'
        },
        {
          label: '1 ते 7 सेवा हमी दाखले online अर्ज',
          url: 'https://rdd.mahaonline.gov.in/'
        },
        {
          label: 'CSC ID वरून B2C सुविधांचा तपशील',
          url: 'https://cscservices.mahaonline.gov.in/Dashboard/Login.aspx'
        },
        {
          label: 'लेखापरिक्षण शक पूर्तता',
          url: 'https://auditonline.gov.in/'
        },
        {
          label: 'ग्रामसभा निर्णय आप वर नोंदवणे',
          url: 'https://meetingonline.gov.in/citizen/homepage'
        },
        {
          label: 'आयुष्मान भारत कार्ड',
          url: 'https://ayushmanidcarddownload.com/'
        },
        {
          label: 'दिव्यांग ओळखपत्र (U-DID)',
          url: 'https://swavlambancard.gov.in/Applyforudid'
        },
        {
          label: 'नळ कनेक्शन धारक कुटुंबांची टक्केवारी',
          url: 'https://ejalshakti.gov.in/jjm/citizen_corner/villageinformation.aspx'
        }
      ],

      copyright:
        '© 2025 मिठमुंबरी ग्रामपंचायत. सर्व हक्क राखीव.'
    },

    en: {
      contactTitle: 'Contact Info',
      address: 'Mithmumbari, Devgad Taluka, District Sindhudurg 416612',
      phone: '9869127240',
      email: 'gpmithmumbari01@gmail.com',

      quickLinksTitle: 'Quick Links',
      links: [
        { label: 'Home', path: '/' },
        { label: 'About Us', path: '/about' },
        { label: 'Citizen Services', path: '/services' },
        { label: 'Events', path: '/events' },
        { label: 'Contact', path: '/contact' }
      ],

      govLinksTitle: 'Important Links',

      govLinksShort: [
        { label: 'Ministry of Panchayati Raj', url: 'https://rdd.maharashtra.gov.in/en/' },
        { label: 'Government of Maharashtra', url: 'https://maharashtra.gov.in/' },
        { label: 'District Collector Office', url: 'https://sindhudurg.nic.in' },
        { label: 'Digital India Portal', url: 'https://www.digitalindia.gov.in' },
        { label: 'PM Kisan Portal', url: 'https://pmkisan.gov.in' },
        { label: 'Ayushman Bharat', url: 'https://beneficiary.nha.gov.in/' },
        { label: 'Grievance Portal', url: 'https://grievances.maharashtra.gov.in/mr' },
        { label: 'Government Resolutions', url: 'https://gr.maharashtra.gov.in/1125/%e0%a4%ae%e0%a5%81%e0%a4%96%e0%a5%8d%e0%a4%af-%e0%a4%aa%e0%a5%83%e0%a4%b7%e0%a5%8d%e0%a4%a0' }
      ],

      govLinksLong: [
        {
          label: 'Birth & death registration (dccrs)',
          url: 'https://dc.crsorgi.gov.in/crs/'
        },
        {
          label: 'Online service guarantee certificates',
          url: 'https://rdd.mahaonline.gov.in/'
        },
        {
          label: 'CSC B2C services',
          url: 'https://cscservices.mahaonline.gov.in/Dashboard/Login.aspx'
        },
        {
          label: 'Audit compliance',
          url: 'https://auditonline.gov.in/'
        },
        {
          label: 'Gram Sabha decision entry',
          url: 'https://meetingonline.gov.in/citizen/homepage'
        },
        {
          label: 'Ayushman Bharat Card',
          url: 'https://ayushmanidcarddownload.com/'
        },
        {
          label: 'UDID Card',
          url: 'https://swavlambancard.gov.in/Applyforudid'
        },
        {
          label: 'Tap water coverage',
          url: 'https://ejalshakti.gov.in/jjm/citizen_corner/villageinformation.aspx'
        }
      ],

      copyright:
        '© 2025 Mithmumbari Gram Panchayat. All rights reserved.'
    }
  };

  const current = content[language];

  return (
    <footer className="bg-gradient-to-br from-green-800 to-teal-700 text-white">
      <div className="max-w-7xl mx-auto px-4 py-12">

        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">

          {/* Contact */}
          <div>
            <h3 className="text-xl font-bold mb-4">{current.contactTitle}</h3>
            <div className="space-y-3 text-sm">
              <div className="flex gap-3"><MapPin size={18} />{current.address}</div>
              <div className="flex gap-3"><Phone size={18} />{current.phone}</div>
              <div className="flex gap-3"><Mail size={18} />{current.email}</div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-xl font-bold mb-4">{current.quickLinksTitle}</h3>
            <ul className="space-y-2 text-sm">
              {current.links.map(l => (
                <li key={l.path}>
                  <Link to={l.path} className="hover:text-green-300">{l.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Gov Links Short */}
          <div>
            <h3 className="text-xl font-bold mb-4">{current.govLinksTitle}</h3>
            <ul className="space-y-2 text-sm">
              {current.govLinksShort.map((item, i) => (
                <li key={i}>
                  <a href={item.url} target="_blank" rel="noreferrer" className="hover:text-green-300">
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Gov Links Long */}
          <div>
            <h3 className="text-xl font-bold mb-4">{current.govLinksTitle}</h3>
            <ul className="space-y-3 text-sm">
              {current.govLinksLong.map((item, i) => (
                <li key={i}>
                  <a href={item.url} target="_blank" rel="noreferrer" className="hover:text-green-300">
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

        </div>

        <div className="border-t border-green-700 mt-8 pt-6 text-center text-sm">
          {current.copyright}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
